import { RestService } from 'src/app/services/rest.service';
import { MenuItem } from './../../@vex/layout/toolbar/toolbar-user/interfaces/menu-item.interface';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from './../../@vex/services/navigation.service';
import { Injectable } from '@angular/core';
import { NavigationItem } from 'src/@vex/interfaces/navigation-item.interface';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {Observable, ReplaySubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GuiService {
  userLogged: any;
  showSpinner = true;
  defaultPath: string = '/login';
  programs = [];
  colorClasses = ['color1', 'color2', 'color3', 'color4', 'color5', 'color6', 'color7'];
  currentProgram: any;
  showSkeleton: boolean;
  dateFormat: string = 'dd/MM/yy';
  originalWorkoutInfo;
  reloadProgram: boolean = false;
  languages = this.translate.getLangs();
  showDownloadSurveyButton = false;

  selectedProgram = sessionStorage.getItem("selectedProgram");

  constructor(private NavigationService: NavigationService, private translate: TranslateService, private _snackBar: MatSnackBar, private router: Router, public restSrv: RestService) { }

  userMenuItems: NavigationItem[] = [
    {
      type: 'link',
      label: 'HOME_LABEL',
      route: 'home',
      icon: 'mat:home',
      routerLinkActiveOptions: { exact: true }
    },
    {
          type: 'link',
          label: 'INFO',
          route: 'info',
          icon: 'mat:contact_support',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'I-PROGRAM',
          route: 'workout-programs',
          icon: 'mat:info',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'NUTRI-CARD',
          route: 'user-nutrition',
          icon: 'mat:restaurant',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'Facebook',
          route: 'facebook',
          icon: 'mat:group',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'WELLNESS.ON_DEMAND',
          route: 'on-demand',
          icon: 'mat:flash_on',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'TABS.DIARY',
          route: 'diary',
          icon: 'mat:book',
          routerLinkActiveOptions: { exact: true }
        }
  ]

  adminMenuItems: NavigationItem[]  = [
    {
      type: 'link',
      label: 'HOME_LABEL',
      route: 'console',
      icon: 'mat:home',
      routerLinkActiveOptions: { exact: true },
      badge: {
        value: '',
        bgClass: '',
        textClass: ''
      }
    },
    {
      type: 'link',
      label: 'USERS',
      route: 'user',
      icon: 'mat:format_list_bulleted',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'SUBS',
      route: 'subs',
      icon: 'mat:view_list',
      routerLinkActiveOptions: { exact: true }
    },
    {
          type: 'link',
          label: 'EX',
          route: 'exercise',
          icon: 'mat:fitness_center',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'WORKS',
          route: 'workout',
          icon: 'mat:assignment',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'WORK-PROG',
          route: 'program',
          faicon: 'faCalendar',
          routerLinkActiveOptions: { exact: true }
        },
    {
      type: 'link',
      label: 'NUTRI',
      route: 'nutrition',
      icon: 'mat:restaurant',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'PROMO',
      route: 'promotion',
      icon: 'mat:card_giftcard',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'NOTIFICATION',
      route: 'admin-notifications',
      icon: 'mat:notifications',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'dropdown',
      label: 'CHALL',
      icon: 'mat:flash_on',
      children: [
        {
          type: 'link',
          label: 'CHALL',
          route: 'challenge'
        },
        {
          type: 'link',
          label: 'TIME-CHALL',
          route: 'time-challenge'
        }
      ]
    },
    {
      type: 'dropdown',
      label: 'WELLNESS_ZONE',
      icon: 'mat:fitness_center',
      children: [
        {
          type: 'link',
          label: 'CATEGORY',
          route: 'categories'
        },
        {
          type: 'link',
          label: 'ASSIGN_ON_DEMAND',
          route: 'assign-ondemand'
        }
      ]
    },
    {
      type: 'link',
      label: 'RECIPES',
      route: 'recipes',
      icon: 'mat:menu_book',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'BANNERS',
      route: 'banner',
      icon: 'mat:panorama',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'ADDONS.TITLE',
      route: 'addons',
      icon: 'mat:extension',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'TROPHIES',
      route: 'trophies',
      icon: 'mat:military_tech',
      routerLinkActiveOptions: { exact: true }
    },
    {
      type: 'link',
      label: 'STREAMING_LABEL',
      route: 'streaming_event',
      icon: 'mat:live_tv',
      routerLinkActiveOptions: { exact: true }
    },
    {
          type: 'link',
          label: 'STATS',
          route: 'reports',
          icon: 'mat:show_chart',
          routerLinkActiveOptions: { exact: true }

    }
  ]

  collabMenuItems: NavigationItem[]  = [
    {
      type: 'link',
      label: 'HOME_LABEL',
      route: 'console',
      icon: 'mat:home',
      routerLinkActiveOptions: { exact: true },
      badge: {
        value: '',
        bgClass: '',
        textClass: ''
      }
    },

        {
          type: 'link',
          label: 'USERS-L',
          route: 'user',
          icon: 'mat:format_list_bulleted',
          routerLinkActiveOptions: { exact: true }
        },

        {
          type: 'link',
          label: 'SUBS-L',
          route: 'subs',
          icon: 'mat:view_list',
          routerLinkActiveOptions: { exact: true }
        },

        {
          type: 'link',
          label: 'WORK-PROG',
          route: 'program',
          faicon: 'faCalendar',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'WORKS',
          route: 'workout',
          icon: 'mat:assignment',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'EX',
          route: 'exercise',
          icon: 'mat:fitness_center',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'NUTRI-CARD',
          route: 'nutrition',
          icon: 'mat:restaurant',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'PROMO-MAN',
          route: '/',
          icon: 'mat:card_giftcard',
          routerLinkActiveOptions: { exact: true }
        },
        {
          type: 'link',
          label: 'CHALL',
          route: '/',
          icon: 'mat:flash_on',
          routerLinkActiveOptions: { exact: true }
        },
    {
          type: 'link',
          label: 'STATS',
          route: '/',
          icon: 'mat:show_chart',
          routerLinkActiveOptions: { exact: true }

    }
  ]

  nutMenuItems: NavigationItem[]  = [
    {
      type: 'subheading',
      label: 'NUTRI',
      children: [
        {
          type: 'link',
          label: 'NUTRI-CARD',
          route: 'customer',
          icon: 'mat:restaurant',
          routerLinkActiveOptions: { exact: true }
        }
      ]
    },
    {
      type: 'link',
      label: 'RECIPES',
      route: 'recipes',
      icon: 'mat:menu_book',
      routerLinkActiveOptions: { exact: true }
    },
  ]

  selectMenuItems(user){
    console.debug(user)
    if(user == 'user'){
      this.NavigationService.items = this.userMenuItems
      this.NavigationService.itemsMenu = this.itemsMenuUser
    }
    if(user == 'admin'){
      this.NavigationService.items = this.adminMenuItems
      this.NavigationService.itemsMenu = this.itemsMenuAdmin
    }
    if(user == 'collaboratore'){
      this.NavigationService.items = this.collabMenuItems
    }
    if(user == 'nutritionist'){
      this.NavigationService.items = this.nutMenuItems
      this.NavigationService.itemsMenu = this.nutriMenuAdmin
    }

  }

  changeLang(lang){
    console.debug(lang)
    this.translate.use(lang)
  }

  openSnackBar(message: string, action?: any, typ?: string, time?:number) {
    let config: MatSnackBarConfig = {}
    config.panelClass = typ ? typ : 'classic';
    config.duration = time ? time : 3000;
    this._snackBar.open(message, action, config);
  }

  itemsMenuUser: MenuItem[] = [
    {
      id: '1',
      icon: 'mat:account_circle',
      label: this.translate.instant('PROFILE_LABEL'),
      description: 'INFO-P',
      colorClass: 'text-teal',
      route: '/main/user/profile'
    },
    {
      id: '4',
      icon: 'mat:table_chart',
      label: 'SUB-P',
      description: 'PLAN-P',
      colorClass: 'text-purple',
      route: '/main/user/sub'
    },
    {
      id: '3',
      icon: 'mat:receipt_long',
      label: 'PROFILE.SUBS.PURCHASE-HISTORY-ADDON',
      description: 'PROFILE.SUBS.PURCHASE-HISTORY-ADDON',
      colorClass: 'text-blue',
      route: '/main/addon-purchase-history'
    },
    {
      id: '2',
      icon: 'mat:vpn_key',
      label: 'password',
      description: 'reset password',
      colorClass: 'text-blue',
      route: '/main/user/reset-password'
    }
  ];

  itemsMenuAdmin: MenuItem[] = [
    {
      id: '1',
      icon: 'mat:account_circle',
      label: this.translate.instant('PROFILE_LABEL'),
      description: 'INFO-P',
      colorClass: 'text-teal',
      route: '/admin/administrator/admin-profile'
    },
    {
      id: '2',
      icon: 'mat:vpn_key',
      label: 'password',
      description: 'reset password',
      colorClass: 'text-blue',
      route: '/admin/administrator/admin-reset-password'
    }
  ];

  nutriMenuAdmin: MenuItem[] = [
    {
      id: '1',
      icon: 'mat:account_circle',
      label: this.translate.instant('PROFILE_LABEL'),
      description: 'INFO-P',
      colorClass: 'text-teal',
      route: '/nutritionist/nutri/nutri-profile'
    },
    {
      id: '2',
      icon: 'mat:vpn_key',
      label: 'password',
      description: 'reset password',
      colorClass: 'text-blue',
      route: '/nutritionist/nutri/nutri-reset-password'
    }
  ];

  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }

   goTo(redirect: string) {
    this.router.navigate([redirect])
  }

  public doLogout() {
    sessionStorage.removeItem("tkn");
    // this.nativeStorage.remove('account'); VEDERE SE SOSTITUIRE CON SESSION STORAGE
    this.restSrv.tkn = null;
    this.restSrv.setTkn(null);
    this.defaultPath = '/login'
    this.router.navigate(["login"]);
  }

  getPrograms() {
    this.showSkeleton = true;
    this.restSrv.postService('workout_programs', '/search?ALL_LANGUAGES=true', { page: 0, size: 0 }).subscribe((ris) => {
      this.programs = [];
      for (let program in ris.items) {
        let checkIfDraft = ris.items[program].workoutProgramStatus
        if (checkIfDraft == 'pubblica') {
          this.programs.push(ris.items[program])
        }
      }
      this.showSkeleton = false;
    })
  }

  evaluateBgColor(index: number): string {
    return this.colorClasses[index % this.colorClasses.length];
  }

  restartAllTutorials(){
    localStorage.removeItem('tourHomeShowed');
    localStorage.removeItem('tourWorkoutProgramsShowed');
    localStorage.removeItem('tourWorkoutProgramDetailShowed');
    localStorage.removeItem('tourChangeWeekShowed');
    localStorage.removeItem('tourWorkoutDetailShowed');
    localStorage.removeItem('tourExerciseDetailShowed');
    localStorage.removeItem('tourWorkoutExecutionShowed');
    localStorage.removeItem('tourWorkoutExecutionRegisterWeightShowed');
    localStorage.removeItem('tourOnDemandShowed');
    localStorage.removeItem('tourDiaryShowed');
    localStorage.removeItem('tourWorkoutHistoryShowed');
    localStorage.removeItem('tourProfileShowed');
    localStorage.removeItem('tourFavoriteWorkoutsShowed');
    localStorage.removeItem('tourNutritionShowed');
    localStorage.removeItem('tourMealShowed');
    localStorage.removeItem('tourMealInfosShowed');
    localStorage.removeItem('tourMealComposeShowed');
    localStorage.removeItem('tourStreamingShowed');
    localStorage.removeItem('tourWorkoutExecutionPauseShowed');
    this.goTo('main/home');
  }

  goToExternalLink(href: string){
    window.open(href, '_blank');
  }

}
